import React from 'react';

export const SellAnyLogo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ className, ...props }) => (
  <img loading="lazy" src="/logo.jpg" 
    alt="SellAny Logo"
    className={className} 
    {...props} 
  />
);